import React, { Component } from 'react';
import Timer from './Timer';


function getSum(total, num) {
    return total + parseInt(num.timerValue, 10);
}

class Workout extends Component {
    constructor(props) {
        super(props);                   
        const steps = props.workout ? props.workout : [];
        const timerLength = steps.reduce(getSum, 0);        
        this.state = {
            steps: steps, 
            currentStep:0, 
            timerLength: timerLength,
            isRunning: false,      
            remainingTime: null,      
            finished:false,
        };
        // This binding is necessary to make `this` work in the callback
        this.addWorkoutStep = this.addWorkoutStep.bind(this);
        this.removeFromList = this.removeFromList.bind(this);        
        this.timerStarted = this.timerStarted.bind(this);      
        this.timerUpdated = this.timerUpdated.bind(this);      
        this.timerCompleted = this.timerCompleted.bind(this);
    }

    removeFromList(stepNumber){      
        var steps = this.state.steps.slice();
        steps.splice(stepNumber-1, 1);        

        var cumulative = 0;
        const stepMap = steps.map((step, stepId) => {             
            const nextStep =
            {
                stepName: step.stepName,                
                timerValue: step.timerValue,
                startTime: cumulative,
                stopTime: cumulative+ parseInt(step.timerValue, 10)
            };
            cumulative += parseInt(step.timerValue, 10);
            return nextStep;
        });
        this.setState({
            steps: stepMap,
            currentStep:0,
            timerLength: cumulative,
            remainingTime: null,
            finished:false,
        });
    }
  
    componentDidUpdate(prevProps, prevState){
        if(prevState.steps !== this.state.steps)
        {
            this.props.updateWorkout(this.state.steps);
        }
        if(prevState.isTimerRunning !== this.state.isTimerRunning)
        {
            console.log("timer state: %s", this.state.isTimerRunning ? "Running" : "Stopped");
        }

        if(prevState.currentStep < this.state.currentStep && this.state.currentStep !== this.state.steps.length)
        {
            this.props.audio.play();
        }
    }

    timerUpdated(timeElapsed)
    {
        const currentItem = this.state.steps[this.state.currentStep];
        const elapsed = Math.round(timeElapsed/1000, 2);        
        if(elapsed > currentItem.stopTime)
        {
            const nextStep = this.state.currentStep + 1 < this.state.steps.length ? this.state.currentStep + 1 : 0;
            const remaining = this.state.steps[nextStep].stopTime - elapsed;            
            this.setState({
                    currentStep: nextStep,                                               
                    remainingTime: remaining,
            });
        }
        else{
            const remaining = currentItem.stopTime - elapsed;
            this.setState({                                
                remainingTime: remaining
            });            
        }
    }

    timerCompleted(stopped){
        this.setState({
            isRunning:false,
            finished:!stopped,
        });
        if(!stopped)
        {                          
            this.props.audio.currentTime = 0;
            this.props.audio.play();            
        }

        console.log("Timer completed");
    }

    timerStarted(){
        this.props.audio.play();        
        this.props.audio.pause();
        const remaining = this.state.steps.length > 0 ? this.state.steps[0].timerValue : 0;
        this.setState({
            isRunning:true,
            finished:false,
            currentStep: 0,
            remainingTime: remaining,
        });
    }

    addWorkoutStep(stepName, timerValue) {    
        if(stepName && timerValue > 0)
        {
            const steps = this.state.steps.slice();
            const timerLength =parseInt(this.state.timerLength, 10); 
            const timerIntValue= parseInt(timerValue, 10);
            const endTime =  timerLength + timerIntValue;
            this.setState({
                steps: steps.concat([{                    
                    stepName: stepName,                   
                    timerValue: timerIntValue,
                    startTime: timerLength,
                    stopTime: endTime,
                }]),
                timerLength: endTime,
                currentStep:0,
                remainingTime: null,
                finished:false,
            });
            return;
        }
    }
    render() {                        
        return (            
        <div className="container">            
            <div className="row mb-2"><div className="col-sm-4"><h1>Workout Timer</h1></div></div>
            <div className="row mb-2"><div className="col-sm-8"><h1 className="text-center">{this.state.remainingTime}</h1></div></div>
            <h3>Steps</h3>
            <Timer startStopDisabled={this.state.steps.length <= 0} totalTimeSeconds={this.state.timerLength} timerStarted={this.timerStarted} tickUpdate={this.timerUpdated} timerCompleted={this.timerCompleted} />                    
            <div className="row">                
                <div className="col-sm-6">                    
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">#</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Time (seconds)</th>                                
                                </tr>                    
                                </thead>
                                <tbody>
                                <WorkoutStepList 
                                    isRunning={this.state.isRunning}                                 
                                    steps={this.state.steps}    
                                    removeFromList={this.removeFromList}
                                    currentStep={this.state.currentStep}       
                                    finished={this.state.finished}                                
                                />
                                </tbody>
                            </table>               
                    <div className="col-sm-6">
                        <h3>Add new step </h3>
                        <WorkoutStepForm  buttonDisabled={this.state.isRunning} addStep={this.addWorkoutStep}/>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}


function WorkoutStepList(props)
{ 
    const steps = props.steps;    
    const stepList = steps.map((step, stepId) => {
        const active = (stepId === props.currentStep);
        return (                
            <WorkoutStep step={stepId+1} 
                name={step.stepName} 
                timer={step.timerValue} 
                key={stepId} 
                removeFromList={props.removeFromList} 
                finished={props.finished}
                pending={stepId > props.currentStep}
                active={active}
                deleteDisabled={props.isRunning} 
            />)
    });
    return stepList;    
}


function WorkoutStep(props)
{
    return(
        <tr className={props.finished ? 'table-success' : (props.pending ? 'table-light' :(props.active  ? 'table-primary':'table-success'))}>
            <td>
                <button title="" type="button"                
                    className="btn btn-danger remove show_tip"
                    data-original-title="Remove from list" onClick={()=>props.removeFromList(props.step)} disabled={props.deleteDisabled}>
                    <i className="fa fa-trash-o"></i>
                </button>
            </td>
            <th scope="row">{props.step}</th>
            <td>{props.name}</td>
            <td>{props.timer}</td>
        </tr>
    );
}


class WorkoutStepForm extends Component {
    constructor(props) {
        super(props);
        this.state = {stepName: '', timerValue: ''};    
        this.handleStepNameChange = this.handleStepNameChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTimerChange = this.handleTimerChange.bind(this);
      }
    
      handleStepNameChange(event) {                    
        this.setState({stepName: event.target.value.replace(/^\s+/,"")});
      }

      handleTimerChange(event) {
        this.setState({timerValue: event.target.value});
      }
    
      handleSubmit(event) {
        event.preventDefault();        
        this.props.addStep(this.state.stepName.trim(), this.state.timerValue);
      }
      render(){
        const buttonDisabled = this.props.buttonDisabled || !(this.state.timerValue > 0 && this.state.stepName !== "");
      return (
            
             <form>
                 <div className="form-group">
                     <label htmlFor="stepName">Step Name</label>
                     <input type="text" className="form-control" id="stepName" value={this.state.stepName} onChange={this.handleStepNameChange} placeholder="Step Name" required />                    
                 </div>
                 <div className="form-group">
                     <label htmlFor="timer">Time (Seconds)</label>
                     <input type="number" className="form-control"
                           id="timer"
                           value={this.state.timerValue}
                           onChange={this.handleTimerChange}
                           placeholder="Time (Seconds)" required/>                    
                 </div>
                 <button type="submit" className="btn btn-primary" onClick={this.handleSubmit} disabled={buttonDisabled}>Add step</button>
             </form>
      );    
    }
}

export default Workout;



// WEBPACK FOOTER //
// ./src/Workout.js